/* eslint-disable react/sort-comp */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import StaticContainer from 'react-static-container';
import get from 'lodash/get';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { findMobileOS } from 'yoda-core-components/lib/helpers/Utils/Utils';
import ErrorBoundary from 'yoda-site-components/lib/components/ErrorBoundary/ErrorBoundary';
import {
    selectDeviceType,
    selectPreferences,
    selectFeatureFlags,
} from 'yoda-site-components/lib/selectors/ContextSelector';
import { selectMarketPlaceSellerInfo } from 'yoda-site-components/lib/selectors/MarketPlaceSelector';
import getSelectedProductImages, {
    getProductImagesAndVideos,
} from 'yoda-site-components/lib/selectors/ProductImageSelector';
import * as styles from './ProductImage.css';
import { pdpToolClickAnalytics, videoPlayerAnalytics } from '../../actions/AnalyticsAction';
import { isBundleProduct } from '../../selectors/Bundle/BundleCommonSelector';
import ProductImageCarousel from '../ProductImageCarousel/ProductImageCarousel';
import formattedFilmStripData from '../../helpers/FormatImagesAndVideos';
import AddToListConnected from '../AddToList/AddToList';
import VerticalZoomCarousel from '../ImageZoom/VerticalZoomCarousel';

const cx = classNames.bind(styles);

let selectedIndex = 0;

export class ProductImage extends Component {
    static defaultProps = {
        actions: {},
        dataAutomationId: null,
        isBundle: false,
        productDetails: {},
        productImages: [],
        productImagesAndVideos: [],
        productOptions: {},
        resizeOnScroll: false,
        virtualTryOnEnabled: false,
        isNative: false,
        enableZoomViewerMobile: true,
        urgencyMessagingEnabled: true,
        addToList: true,
        enableVideoPlacementChange: false,
        preferences: {},
        isMobilePDPImageZoomed: false,
        isOrientationLandscapeForZoom: false,
        featureFlags: {},
        marketPlaceSellerInfo: {},
    };

    static propTypes = {
        actions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        dataAutomationId: PropTypes.string,
        deviceType: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        isBundle: PropTypes.bool,
        productDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        preferences: PropTypes.oneOfType([PropTypes.object]),
        productImages: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        productImagesAndVideos: PropTypes.oneOfType([PropTypes.array]),
        productOptions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        /**
         * This option enables the product image carousel to become small
         * on scrolling.
         * @type {Boolean}
         */
        resizeOnScroll: PropTypes.bool,
        virtualTryOnEnabled: PropTypes.bool,
        isNative: PropTypes.bool,
        enableZoomViewerMobile: PropTypes.bool,
        enableVideoPlacementChange: PropTypes.bool,
        urgencyMessagingEnabled: PropTypes.bool,
        addToList: PropTypes.bool,
        isMobilePDPImageZoomed: PropTypes.bool,
        isOrientationLandscapeForZoom: PropTypes.bool,
        featureFlags: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        marketPlaceSellerInfo: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    };

    constructor() {
        super();

        this.state = {
            isImageZoomVisible: false,
            shouldAnalyticsTrigger: true,
            showAddToList: true,
        };
    }

    componentDidMount() {
        const { resizeOnScroll } = this.props;

        /* istanbul ignore next */
        if (resizeOnScroll && this.imgContainerRef) {
            // to add height for pagination dots.
            const calculatedHeight = this.imgContainerRef.offsetHeight + 24;

            this.imgContainerRef.style.minHeight = `${calculatedHeight}px`;
        }
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps({ productOptions }) {
        /* istanbul ignore next */
        if (
            this.props.productOptions !== productOptions &&
            productOptions &&
            Object.keys(productOptions).length
        ) {
            this.setState({ shouldAnalyticsTrigger: false });
        }
    }

    toggleImageZoomVisibility = () => {
        const { actions, productImages } = this.props;

        // eslint-disable-next-line react/no-access-state-in-setstate
        this.setState({ isImageZoomVisible: !this.state.isImageZoomVisible });

        if (!this.state.isImageZoomVisible) {
            actions.pdpToolClickAnalytics(`image zoom - 1/${productImages[0].altText}`);
        }
    };

    loadScene7Success = (idx) => {
        const videoPlayerData = window.videojs(idx);
        this.props.actions.videoPlayerAnalytics(videoPlayerData);
    };

    slideCallback = (idx) => {
        selectedIndex = idx;
        this.handleAnalytics();
        const {
            productImagesAndVideos,
            enableVideoPlacementChange,
            preferences: { videoPlacementPosition = 3 } = {},
        } = this.props;
        const updatedproductImagesAndVideos = enableVideoPlacementChange
            ? formattedFilmStripData(videoPlacementPosition, productImagesAndVideos)
            : productImagesAndVideos;

        if (
            !__SERVER__ &&
            findMobileOS() === 'iOS' &&
            updatedproductImagesAndVideos &&
            (updatedproductImagesAndVideos[selectedIndex] || {}).isVideo
        ) {
            this.setState({ showAddToList: false });
        } else {
            this.setState({ showAddToList: true });
        }
    };

    handleAnalytics = () => {
        /* istanbul ignore else */
        if (this.state.shouldAnalyticsTrigger) {
            this.props.actions.pdpToolClickAnalytics('alternate images');
        }

        this.setState({ shouldAnalyticsTrigger: true });
    };

    render() {
        const {
            productImages,
            deviceType,
            dataAutomationId,
            productDetails,
            isBundle,
            productImagesAndVideos,
            virtualTryOnEnabled,
            isNative,
            enableZoomViewerMobile,
            urgencyMessagingEnabled,
            addToList,
            enableVideoPlacementChange,
            preferences: { videoPlacementPosition = 3 } = {},
            isMobilePDPImageZoomed,
            isOrientationLandscapeForZoom,
            featureFlags,
            marketPlaceSellerInfo,
        } = this.props;
        const renderImageZoom = (
            <div>
                <ErrorBoundary>
                    <VerticalZoomCarousel
                        productImages={productImages}
                        productImagesAndVideos={
                            enableVideoPlacementChange
                                ? formattedFilmStripData(
                                      videoPlacementPosition,
                                      productImagesAndVideos
                                  )
                                : productImagesAndVideos
                        }
                        enableVideoPlacementChange={enableVideoPlacementChange}
                        selectedIndex={selectedIndex}
                        dataAutomationId="VerticalImageZoom"
                        closeCallback={this.toggleImageZoomVisibility}
                        isNative={isNative}
                    />
                </ErrorBoundary>
            </div>
        );
        const ppid = productDetails.id || '';

        const productImageBlock = (
            <ErrorBoundary>
                <ProductImageCarousel
                    isCarouselTabDisplay={!enableVideoPlacementChange && enableZoomViewerMobile}
                    dataAutomationId={dataAutomationId}
                    productImagesAndVideos={productImagesAndVideos}
                    onImageClick={this.toggleImageZoomVisibility}
                    slideCallback={this.slideCallback}
                    triggerAnalytics={this.loadScene7Success}
                    deviceType={deviceType}
                    displayTapOnZoom={deviceType.isMobile || deviceType.isTablet}
                    isBundle={isBundle}
                    selectedIndex={selectedIndex}
                    urgencyMessagingEnabled={urgencyMessagingEnabled}
                    enableVideoPlacementChange={enableVideoPlacementChange}
                    ppId={ppid}
                    enableZoomOnProductImage={featureFlags.enableZoomOnProductImage}
                    isMobilePDPImageZoomed={isMobilePDPImageZoomed}
                    isOrientationLandscapeForZoom={isOrientationLandscapeForZoom}
                    isMarketPlaceProduct={get(marketPlaceSellerInfo, 'isMarketPlaceProduct', false)}
                    enableMarketPlace={featureFlags.enableMarketPlace}
                />
            </ErrorBoundary>
        );

        const vtoStyles = virtualTryOnEnabled
            ? ['sm:!h-0', 'invisible']
            : ['sm:!h-auto', 'visible'];

        let isExecuteOldLayout = !(featureFlags.enableZoomOnProductImage && !isBundle);
        if (isOrientationLandscapeForZoom) {
            isExecuteOldLayout = true;
        }
        return (
            <div className={dt(['w-full', 'h-full', ...vtoStyles])}>
                <div
                    className={cx('ProdImgContainer')}
                    ref={(el) => {
                        this.imgContainerRef = el;
                    }}
                >
                    {/* This is fake container for zoom viewer to do initial set up  */}
                    <StaticContainer>
                        <div id="fakeZoomViewer" hidden />
                    </StaticContainer>
                    {!isBundle &&
                    this.state.showAddToList &&
                    addToList &&
                    !(
                        featureFlags.enableMarketPlace &&
                        get(marketPlaceSellerInfo, 'isMarketPlaceProduct', false)
                    ) ? (
                        <ErrorBoundary>
                            <section className={cx('addToListContainer')}>
                                <AddToListConnected ppId={ppid} />
                            </section>
                        </ErrorBoundary>
                    ) : null}
                    {productImageBlock}
                    {isExecuteOldLayout && this.state.isImageZoomVisible ? renderImageZoom : null}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    productImages: getSelectedProductImages(false)(state),
    productImagesAndVideos: getProductImagesAndVideos(false)(state),
    analytics: state.Analytics,
    productOptions: state.productOptions,
    deviceType: selectDeviceType(state),
    isBundle: isBundleProduct(state),
    isNative: get(state.context, 'isNative', false),
    enableZoomViewerMobile: get(state, 'context.featureFlags.enableZoomViewerMobile', true),
    urgencyMessagingEnabled: get(state, 'context.featureFlags.urgencyMessagingEnabled', true),
    addToList: get(state, 'context.featureFlags.addToList', true),
    enableVideoPlacementChange: get(
        state,
        'context.featureFlags.enableVideoPlacementChange',
        false
    ),
    preferences: selectPreferences(state),
    featureFlags: selectFeatureFlags(state),
    marketPlaceSellerInfo: selectMarketPlaceSellerInfo(false)(state),
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            /* Analytics Actions */
            pdpToolClickAnalytics,
            videoPlayerAnalytics,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductImage);
